"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconFormat = IconFormat;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("@eig-builder/core-ui/Icon"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function IconFormat(params) {
  var tooltip = _objectSpread({
    text: '',
    pos: ''
  }, params.colDef.tooltip);

  var icon = /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: params.value,
    className: "data-table-icon"
  });

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "icon-wrapper",
    "data-balloon": tooltip && tooltip.text,
    "data-balloon-pos": tooltip && tooltip.pos || 'up',
    onClick: function onClick() {
      return params.colDef.clickFunction(params.data.id);
    }
  }, icon);
}